import React from 'react';
import Proptypes from 'prop-types';
import { FDImage } from '@facet-wealth/design';

export const RiskToleranceImage = ({ value }) => {
  if (!value) {
    return null;
  }
  return (
    <FDImage src={value} alt={'risk tolerance'} />
  );
};

RiskToleranceImage.propTypes = {
  value: Proptypes.string.isRequired,
};
